import {fromEvent, merge, Subject} from 'rxjs';
import {debounceTime, filter, map, startWith} from 'rxjs/operators';
import {breakPoints} from './react-safe-viewport-functions';

const events = new Subject();

const source = merge(fromEvent(window, 'resize'), events);

export function responsiveImageLoaded() {
    events.next(null);
}

export function detectViewportWidth(noInitialValue?) {
    let lastWindowWidth = window.innerWidth;

    const ret = source
        .pipe(debounceTime(300))
        .pipe(
            filter(() => {
                if (window.innerWidth !== lastWindowWidth) {
                    lastWindowWidth = window.innerWidth;
                    return true;
                }
                return false;
            }),
        )
        .pipe(
            map(() => {
                return getBreakpoint();
            }),
        );
    return noInitialValue ? ret : ret.pipe(startWith(getBreakpoint()));
}

export function getBreakpoint() {
    const currentWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    for (const breakpoint of breakPoints) {
        if (currentWidth >= breakpoint.min && currentWidth <= breakpoint.max) {
            return breakpoint.name;
        }
    }
}

function breakpointCompare(a, b, operator) {
    let i1 = 0;
    let i2 = breakPoints.length;
    for (let i = 0; i < breakPoints.length; i++) {
        if (breakPoints[i].name === a) {
            i1 = i;
            break;
        }
    }
    for (let i = 0; i < breakPoints.length; i++) {
        if (breakPoints[i].name === b) {
            i2 = i;
            break;
        }
    }
    if (operator === '>') {
        return i1 > i2;
    }
    return i1 < i2;
}

export function breakpointLessThan(breakpoint, current) {
    return breakpointCompare(breakpoint, current, '<');
}
